import { PaletteMode } from '@mui/material';
import {
  chronoDefinedDarkTokens,
  chronoDefinedLightTokens,
  unitySemanticDarkColorTokens,
  unitySemanticLightColorTokens,
} from '@/theme/unityTokens';
import { GetThemeOptions } from '../../theme';
import { ChronosphereColorPalette, orange } from '../colors';

export const warningColor = (mode: PaletteMode, opts: GetThemeOptions): ChronosphereColorPalette => {
  if (opts.panwRebrandStubYear) {
    const semanticTokens = mode === 'light' ? unitySemanticLightColorTokens : unitySemanticDarkColorTokens;
    const chronoTokens = mode === 'light' ? chronoDefinedLightTokens : chronoDefinedDarkTokens;
    return {
      main: semanticTokens['--semantic-data-informative-intermediate'],
      highContrast: chronoTokens['--data-informative-intermediate-high-contrast'],
      lowContrast: chronoTokens['--data-informative-intermediate-low-contrast'],
    };
  }

  return mode === 'light'
    ? {
        main: orange[400],
        highContrast: orange[700],
        lowContrast: orange[100],
      }
    : {
        main: orange[400],
        highContrast: orange[100],
        lowContrast: orange[800],
      };
};
